import {Component, Input} from '@angular/core';
import {isNativeCapacitorPlatform} from '../../../shared/platform';
import {MonetizationLinkPurpose, MonetizationPolicyService} from '../../monetization/monetization-policy.service';
import {ExternalBrowserService} from '../../external-browser.service';

@Component({
  selector: 'sm-policy-link',
  templateUrl: './sm-policy-link.component.html',
  styleUrls: ['./sm-policy-link.component.scss'],
  standalone: false,
})
export class SmPolicyLinkComponent {
  @Input() href = '';
  @Input() externalHref = '';
  @Input() openInExternalBrowser = false;
  @Input() purpose: MonetizationLinkPurpose = 'support';
  @Input() ariaLabel = '';

  constructor(
    readonly monetizationPolicy: MonetizationPolicyService,
    private readonly externalBrowser: ExternalBrowserService,
  ) {}

  get isClickable(): boolean {
    return Boolean(this.href) && this.monetizationPolicy.canRenderLink(this.purpose);
  }

  async handleClick(event: MouseEvent): Promise<void> {
    if (!this.isClickable) {
      event.preventDefault();
      return;
    }

    if (!this.openInExternalBrowser || !isNativeCapacitorPlatform()) {
      return;
    }

    event.preventDefault();
    await this.externalBrowser.open(this.externalHref || this.href);
  }
}
